module.exports = __webpack_public_path__ + "img/03.8792a779.png";